import { FinalizarCadastro } from "./FinalizarCadastro";

export default FinalizarCadastro;